export interface BirthDayDetails {
  customerName: string;
  customerLastName: string;
  email: string;
  phone: string;
  isInvoice: boolean;
  additionalInfo: string;
}

export const initialBirthDayDetails = {
  customerName: "",
  customerLastName: "",
  email: "",
  phone: "",
  isInvoice: false,
  additionalInfo: ""
} as BirthDayDetails;
